import styled from 'styled-components';

export const ErrorMessage = styled.p`
  margin: 0;
  color: red;
`;
